import { styled } from 'goober'
import { useTheme } from '../useTheme'

export const useBaseStyles = () => {
  const theme = useTheme()

  return {
    P: styled('p')({
      margin: 0,
      padding: 0
    }),

    CustomTypography: styled('p')(({ ...props }) => ({
      margin: 0,
      padding: 0,
      ...props
    })),

    FlexBox: styled('div')({
      display: 'flex',
      alignItems: 'center'
    }),

    CustomFlexBox: styled('div')(
      ({
        alignItems,
        justifyContent = '',
        gap = '',
        flexDirection = 'row'
      }) => ({
        display: 'flex',
        flexDirection,
        alignItems,
        justifyContent,
        gap
      })
    ),

    CollapsibleWrapper: styled('div')(({ inProp }) => ({
      position: 'sticky',
      top: 0,
      zIndex: inProp ? 100 : 10,
      backgroundColor: theme.palette.background.paper || '#fff',
      transition: 'all 0.3s ease',
      ...(inProp && {
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)'
      })
    })),

    OverlayWrapper: styled('div')(({ inProp }) => ({
      position: 'relative',
      height: '100%',
      transition: 'all 0.3s ease',
      ...(inProp && {
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor:
            theme.palette.mode === 'dark'
              ? 'rgba(0, 0, 0, 0.5)'
              : 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(2px)',
          zIndex: 1,
          pointerEvents: 'none',
          animation: 'fadeIn 0.3s ease'
        },
        '& > *': {
          position: 'relative',
          opacity: 0.5,
          filter: 'grayscale(50%)',
          pointerEvents: 'none',
          userSelect: 'none',
          transition: 'opacity 0.3s ease, filter 0.3s ease'
        }
      }),
      '@keyframes fadeIn': {
        from: {
          opacity: 0
        },
        to: {
          opacity: 1
        }
      }
    })),

    Spacer: styled('div')(({ mx = '0.8rem', my = 0 }) => ({
      margin: `${mx} ${my}`
    }))
  }
}
